(ns app.front.view.admin.migration.bill-modified-ts
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/add-bill-modified-ts
    :title     "Add modification timestamp to bill entities"
    :help-text (str "Bill modification timestamp will be set to the transaction time of latest state change for "
                    "bills that currently do not have it.")}
   match])

(def route
  {:name        :view/admin.migration.bill-modified-ts
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/add-bill-modified-ts]))}]})
